import vm from "../main";
import axios from "./PointrCloudAxios";
import ToastHelpers from "@/helpers/ToastHelpers";

export default class PersonaService {
  static async getPersonas(clientInternalIdentifier) {
    let response;
    try {
      response = await axios.get(`/content/draft/clients/${clientInternalIdentifier}/personas`);
    } catch (error) {
      console.error(error);
      return [];
    }
    return response?.data;
  }

  static async addPersona(payload, clientInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(`content/draft/clients/${clientInternalIdentifier}/personas`, payload);
      return response?.data;
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || `${vm.$t("contents.fail-message")}`
      );
      throw error.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
  }

  static async updatePersona(payload, clientInternalIdentifier, personaIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.put(
        `/content/draft/clients/${clientInternalIdentifier}/personas/${personaIdentifier}`,
        payload
      );
      return response?.data;
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || `${vm.$t("contents.fail-message")}`
      );
      throw error.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
  }

  static async deletePersona(clientInternalIdentifier, personaIdentifier) {
    vm.$store.commit("ADD_LOADING_REQUEST");
    let response;
    try {
      response = await axios.delete(`/content/draft/clients/${clientInternalIdentifier}/personas/${personaIdentifier}`);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw error.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
  }
}
